import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { UncontrolledTooltip } from 'reactstrap';

import PendingApprovalLink from './PendingApprovalLink';
import { cfPath } from '../../utilities/UrlPaths';
import AuctionGroupHeader from './AuctionGroupHeader';

/**
 * This is a clean slate version of a newly created auction group that does not have
 * any sales yet.  There are different required settings for ReactTable, and the columns
 * themselves are different than an actual AuctionGroup
 */
const EmptyAuctionGroup = ({
  house,
  group,
  type,
  user,
  disableAddSaleAndSessionButton,
  disableAddSessionButton
}) => {
  const { isHouseFeeStepActive } = house;
  const { accessCustomer } = user;
  const {
    catalogs,
    groupID,
    groupName,
    groupSettingsID,
    houseFeeStepEnabled,
    pendingApprovalsCount,
    live
  } = group;

  const disableAddSession = isHouseFeeStepActive !== houseFeeStepEnabled
    || disableAddSaleAndSessionButton || disableAddSessionButton;

  const cantAddSessionTooltipText = disableAddSaleAndSessionButton ? 'Complete payment processing sign up to upload new sales.' : 'Your house has a different fee structure than this group, so in order to prevent invoice errors you can\'t add new sessions to this group. Please create a new group.';

  // For newly created sales, we have no catalogs yet - so return a stubbed out table
  if (type === 'current' && catalogs.length === 0) {
    const emptyColumns = [
      {
        Header: 'Cover Photo',
        width: 120
      },
      {
        Header: 'Date & Time',
        width: 180
      },
      {
        Header: 'Session Title'
      },
      {
        Header: '# of Lots',
        width: 80
      },
      {
        Header: 'Preview Links',
        width: 140
      },
      {
        Header: 'Actions',
        width: 265
      }
    ];
    return (
      <div className="mb-4">
        <div className="auction-container px-3">
          <AuctionGroupHeader groupName={groupName} live={live} />
          <span className="float-end">
            <a
              className="link-secondary px-2"
              href={`${cfPath()}/al/settings/groupSettings.cfm?groupID=${groupID}&groupSettingsID=${groupSettingsID}&isDefault=false`}
            >
              Edit Terms
            </a>{' '}
            |
            <PendingApprovalLink
              accessCustomer={accessCustomer}
              groupID={groupID}
              pendingApprovalsCount={pendingApprovalsCount}
            />{' '}
            |
            {disableAddSession ? (
              <span id={`disableSessionWarningIcon_${groupID}`} className="link-secondary px-2 color-danger">
                <FontAwesomeIcon className="color-danger" icon="exclamation-triangle" />
                <UncontrolledTooltip
                  placement="left"
                  target={`disableSessionWarningIcon_${groupID}`}
                >
                  {cantAddSessionTooltipText}
                </UncontrolledTooltip>{' '}
                Can&apos;t Add Session
              </span>
            ) : (
              <Link
                className="link-secondary px-2"
                to={`/session/${!live ? 'timed' : 'live'}/${groupID}/0/1`}
              >
                + Add Session
              </Link>
            )}
          </span>
        </div>
        <ReactTable
          minRows={0}
          columns={emptyColumns}
          showPagination={false}
          style={{ width: '100%' }}
          className="-highlight"
        />
        <div className="p-3 empty-table-text">
          <div className="mb-2">
            <strong>You have no sessions for this online auction yet.</strong>
          </div>
          {!disableAddSession ? (
            <div>
              To add one or more sale days,{' '}
              <Link to={`/session/${!live ? 'timed' : 'live'}/${groupID}/0/1`}>Add Session.</Link>
            </div>
          ) : (
            <div>{cantAddSessionTooltipText}</div>
          )}
        </div>
      </div>
    );
  }
  return null;
};

const mapStateToProps = ({ user }) => ({
  user
});

export default connect(
  mapStateToProps,
  null
)(EmptyAuctionGroup);
